import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { Row, Col, Card } from "react-bootstrap";
import CalendarSection from "./CalendarSection";
import DetailSection from "./DetailSection";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import {
  useObtenerVentasPorAno,
  VentasDelMes,
} from "../../../services/ventasServicios";
import ServerErrorModal from "../../organisms/ServerErrorModal";
import LoadingScreen from "../../organisms/LoadingScreen";

function MasterDetailSection() {
  const [animationParent] = useAutoAnimate<HTMLDivElement>();
  const [detailAnimationParent] = useAutoAnimate<HTMLDivElement>();

  const { data: ventasPorAno, isLoading, error } = useObtenerVentasPorAno();

  const { ventasDelMesDeHoy, fechaHoy } = useMemo(() => {
    const hoy = new Date();
    const anoHoy = hoy.getFullYear();
    const mesHoy = hoy.getMonth() + 1;
    return { ventasDelMesDeHoy: ventasPorAno?.[anoHoy]?.[mesHoy], fechaHoy: hoy };
  }, [ventasPorAno]);

  const [ventasDelMes, setVentasDelMes] = useState<VentasDelMes | undefined>(
    ventasDelMesDeHoy
  );

  const [fechaMes, setFechaMes] = useState<Date | undefined>(undefined);

  useEffect(() => {
    if (ventasDelMesDeHoy && !ventasDelMes) {
      setVentasDelMes(ventasDelMesDeHoy);
      setFechaMes(fechaHoy);
    }
  }, [ventasDelMesDeHoy, ventasDelMes, fechaHoy]);

  const onVentaMesSeleccionado = (
    ventasDelMes: VentasDelMes,
    fechaDelMes: Date
  ) => {
    setVentasDelMes(ventasDelMes);
    setFechaMes(fechaDelMes);
  };

  if (isLoading) {
    return <LoadingScreen isLoading={true} />;
  }

  if (error) {
    return <ServerErrorModal />;
  }

  return (
    <StyledRow>
      <Col
        sm={ventasDelMes ? "12" : "6"}
        className="justify-content-center align-items-center"
      >
        <StyledCard>
          <StyledCardBody>
            <Row
              ref={animationParent}
              className="justify-content-center align-items-center"
            >
              <Col sm={ventasDelMes ? "6" : "12"}>
                {!isLoading && !error && !!ventasPorAno && (
                  <CalendarSection
                    onVentaMesSeleccionado={onVentaMesSeleccionado}
                    ventasPorAno={ventasPorAno}
                  />
                )}
              </Col>
              {ventasDelMes && fechaMes && (
                <Col sm="12" ref={detailAnimationParent}>
                  <DetailSection
                    ventasDelMes={ventasDelMes}
                    fechaMes={fechaMes}
                  />
                </Col>
              )}
            </Row>
          </StyledCardBody>
        </StyledCard>
      </Col>
    </StyledRow>
  );
}

const StyledRow = styled(Row)`
  justify-content: center;
`;

const StyledCard = styled(Card)`
  margin-bottom: 1.875rem;
  background-color: #fff;
  transition: all 0.5s ease-in-out;
  position: relative;
  border: 0px solid transparent;
  border-radius: 0.25rem;
  box-shadow: 0px 0px 13px 0px rgb(82 63 105 / 5%);
`;

const StyledCardBody = styled(Card.Body)`
  padding: 1.25rem;
`;

export default MasterDetailSection;
